module.exports = __webpack_public_path__ + "img/2.3d7019de.png";